import { render, staticRenderFns } from "./DanhSachVaiTroKhongThuocNguoiDung.vue?vue&type=template&id=5705f714&"
import script from "./DanhSachVaiTroKhongThuocNguoiDung.vue?vue&type=script&lang=js&"
export * from "./DanhSachVaiTroKhongThuocNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports